
/**
  Create an <img> tag and insert it into a container element sized such that 
  it covers the entirety of the container element, stretching and clipping parts 
  of the image as necessary.

  options: {
    imageSrc: what is the image's URL to load
    container: the DOM element into which the image will be inserted
    imageClassName: the classname for the image element
  }
*/
const loadFittedImage = function({ 
  container,
  imageSrc,
  altText,
  imageClassName='',
  imageCss={},
  enableBackgroundCover=false
}) {

  var deferred = $.Deferred();
  var $container = $(container);


  var $img = $('<img/>');
  $img.addClass(imageClassName);
  $container.html($img);
  $img.css({
    'visibility': 'hidden',
    'position': 'absolute'
  });
  
  $img.load(function(){
    var width, height;
    var trueWidth = this.naturalWidth || this.width; 
    var trueHeight = this.naturalHeight || this.height;
    
    // in IE 11, on first uncached load of an image,
    // sometimes it will mistake the image for the "broken image" default image
    // which has a height of 30 and a width of 28. So we just blacklist
    // that size in a heinous hack, whose goal is to make IE11 actually work
    if(!trueHeight || !trueWidth || (trueHeight == 30 && trueWidth == 28)){
      return;
    }
    
    var hideBackgroundCover = function() {
      $img.show();
      $container.css({ 'background-image': '' });        
    };

    var imageRatio = (trueWidth * 1.0) / trueHeight;
    var containerRatio = ($container.width() * 1.0) / $container.height();
    if (imageRatio > containerRatio){
      width = Math.min($container.width(), trueWidth);
      height = width / imageRatio;
    } else{
      height = Math.min($container.height(), trueHeight);
      width = height * imageRatio;
    }
    
    $img.css('visibility', 'visible');


    if (trueWidth < $container.width() && trueHeight < $container.height()) {

      if (enableBackgroundCover) {
        hideBackgroundCover();
      }        

      $img.css({
        ...imageCss,
        'left': '50%',
        'margin-left': '-'+ (trueWidth/2) + 'px',
        'top': '50%',
        'margin-top': '-'+ (trueHeight/2) + 'px',
        'height': '' + trueHeight + 'px',
        'width': '' + trueWidth + 'px'
      });
    } else if (enableBackgroundCover && trueWidth > $container.width() && trueHeight > $container.height()) {

      $container.css({
        ...imageCss,
        'background-image': 'url(' + $img.attr('src') + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'background-repeat': 'no-repeat'
      });
      $img.hide();

    } else if (imageRatio > containerRatio){

      if (enableBackgroundCover) {
        hideBackgroundCover();
      }      

      $img.css({
        ...imageCss,
        'width': '' + (width - 2) + 'px', //prevent auto scroll
        'height': 'auto',
        'top': '50%',
        'margin-top': '-'+ (height/2) + 'px',
        'left': '0',
        'margin-left': '0px'
      });
    } else {

      if (enableBackgroundCover) {
        hideBackgroundCover();
      }      

      $img.css({
        ...imageCss,
        'width': 'auto',
        'height':  '' + (height - 2) + 'px', //prevent auto scroll
        'left': '50%',
        'margin-left': '-'+ (width/2) + 'px',
        'top': '0',
        'margin-top': '0px'
      });
    }

    deferred.resolve();
    
  })
  .attr('src', imageSrc)
  .attr('alt', altText);
  
  return deferred.promise();
  
};

export default loadFittedImage;